function CategoriesTab({ categories, onAdd, onEdit, onDelete }) {
    return (
        <div className="admin__section">
            <button className="admin__add-btn" onClick={onAdd}>
                + Adaugă categorie
            </button>
            <table className="admin__table">
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>Nume</th>
                        <th>Culoare</th>
                        <th>Acțiuni</th>
                    </tr>
                </thead>
                <tbody>
                    {categories.map((c) => (
                        <tr key={c.id}>
                            <td>{c.id}</td>
                            <td>{c.name}</td>
                            <td>
                                <span
                                    className="admin__color-preview"
                                    style={{ backgroundColor: c.color || "#b33771" }}
                                />
                                {c.color || "#b33771"}
                            </td>
                            <td>
                                <button onClick={() => onEdit(c)}>Editează</button>
                                <button onClick={() => onDelete(c.id)} className="delete">
                                    Șterge
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}

export default CategoriesTab;
